import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import get from 'lodash/fp/get';
var config = window.__config;
export var AUTH_STATUSES = {
  LOGGED_IN: 'logged-in',
  LOGGED_OUT: 'logged-out'
};
export var getCachedAuthStatus = function getCachedAuthStatus() {
  return window.sessionStorage && window.sessionStorage.getItem('auth-status') || AUTH_STATUSES.LOGGED_OUT;
};
var setCachedAuthStatus = function setCachedAuthStatus(status) {
  return window.sessionStorage && window.sessionStorage.setItem('auth-status', status);
};
var setAuthStatusBodyClass = function setAuthStatusBodyClass() {
  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCachedAuthStatus();
  document.body.classList.remove("user-".concat(AUTH_STATUSES.LOGGED_IN));
  document.body.classList.remove("user-".concat(AUTH_STATUSES.LOGGED_OUT));
  document.body.classList.add("user-".concat(status));
};
var queryRemoteAppAuthStatus = new Promise(function (resolve, reject) {
  var iframe = document.createElement('iframe');
  iframe.setAttribute('src', "".concat(config.appUrl, "/embed/auth-status"));
  iframe.style = 'display: none; width: 0px; height: 0px; pointer-events: none;';
  iframe.addEventListener('load', function () {
    window.addEventListener('message', function (event) {
      if (event.origin !== config.appUrl) return;
      if (get('data.type', event) !== 'AUTH_STATUS') return;
      resolve(get('data.status', event));
    }, false);
    iframe.contentWindow.postMessage('request-auth-status', config.appUrl);
  });
  document.body.appendChild(iframe);
});
var timeoutRemoteAppAuthStatus = new Promise(function (resolve, reject) {
  return setTimeout(function () {
    return resolve(AUTH_STATUSES.LOGGED_OUT);
  }, 2500);
});
export default /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var status, remoteStatus;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          status = setCachedAuthStatus();
          if (!status) {
            _context.next = 5;
            break;
          }
          setAuthStatusBodyClass(status);
          _context.next = 10;
          break;
        case 5:
          _context.next = 7;
          return Promise.race([queryRemoteAppAuthStatus, timeoutRemoteAppAuthStatus]);
        case 7:
          remoteStatus = _context.sent;
          setCachedAuthStatus(remoteStatus);
          setAuthStatusBodyClass(remoteStatus);
        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));